<template>
  <div class="message-form">
    <div class="form-group">
      <label class="form-label">Neue Notiz</label>
      <textarea 
        v-model="message.message" 
        class="input w-full" 
        rows="3" 
        placeholder="Notiz eingeben..."
        v-bind:class="{ 'input-error': errors.message }">
      </textarea>
      <div class="input-error-message" v-if="errors.message">{{ errors.message[0] }}</div>
    </div>
    
    <div class="flex gap-2 mt-2">
      <button @click="saveMessage" class="btn btn-primary btn-small" :disabled="saving">
        <span v-if="saving">Speichern...</span>
        <span v-else>Speichern</span>
      </button>
      <button @click="cancelMessage" class="btn btn-secondary btn-small" v-if="showCancel">
        Abbrechen
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dossier', 'showCancel'],
  data() {
    return {
      message: {
        message: '',
        type: 'Message'
      },
      errors: {},
      saving: false
    }
  },
  methods: {
    saveMessage: function () {
      if (!this.message.message.trim()) {
        this.errors = { message: ['Notiz darf nicht leer sein'] }
        return
      }

      this.saving = true
      this.errors = {}

      const url = `/diesel_dossiers/${this.dossier.id}/messages`
      
      this.$http.post(url, { message: this.message }).then(response => {
        Vue.$toast.success('Notiz wurde gespeichert.')
        this.message.message = ''
        this.saving = false
        this.$emit('message-created', response.body)
      }, response => {
        this.saving = false
        if (response.status === 422) {
          this.errors = response.body
        } else {
          Vue.$toast.error('Fehler beim Speichern der Notiz.')
        }
      })
    },
    
    cancelMessage: function () {
      this.message.message = ''
      this.errors = {}
      this.$emit('cancelled')
    }
  }
}
</script>